import React, { useState } from 'react';
import { ExternalLink, BookOpen, ChevronDown, ChevronUp } from 'lucide-react';
import { getConnectionSetupGuide } from '../../data/connectionSetupGuides';

const ConnectionSetupGuide = ({ provider, defaultOpen = true, compact = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  if (!provider) return null;

  const guide = getConnectionSetupGuide(provider);

  return (
    <div
      key={provider.id}
      className="rounded-xl border border-sky-500/25 bg-sky-500/5 overflow-hidden"
      data-testid={`conn-guide-${provider.id}`}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-2 px-4 py-3 text-left hover:bg-sky-500/5 transition-colors"
      >
        <span className="flex items-center gap-2 text-xs font-medium text-sky-200">
          <BookOpen className="w-3.5 h-3.5 shrink-0" />
          {guide.title}
        </span>
        {open ? <ChevronUp className="w-4 h-4 text-sky-400" /> : <ChevronDown className="w-4 h-4 text-sky-400" />}
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-3 border-t border-sky-500/15">
          {!compact && guide.usedFor ? (
            <p className="text-[11px] text-zinc-400 pt-2">
              <span className="text-zinc-500">Used for: </span>
              {guide.usedFor}
            </p>
          ) : null}
          <ol className="list-decimal list-inside space-y-1.5 text-[11px] text-zinc-300 leading-relaxed">
            {guide.steps.map((step) => (
              <li key={step} className="pl-0.5">
                {step.split('**').map((part, i) => (
                  i % 2 === 1 ? <strong key={`${step}-${i}`} className="text-white font-medium">{part}</strong> : part
                ))}
              </li>
            ))}
          </ol>
          {guide.links?.length > 0 && (
            <div className="flex flex-wrap gap-3 pt-1">
              {guide.links.map((link) => (
                <a
                  key={link.url}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-[11px] text-sky-300 hover:text-sky-200"
                >
                  {link.label}
                  <ExternalLink className="w-3 h-3" />
                </a>
              ))}
            </div>
          )}
          {!compact && guide.afterConnect ? (
            <p className="text-[10px] text-zinc-500 border-t border-sky-500/10 pt-2 leading-relaxed">
              <span className="text-zinc-400">After connecting: </span>
              {guide.afterConnect.split('**').map((part, i) => (
                i % 2 === 1 ? <strong key={`after-${i}`} className="text-zinc-300">{part}</strong> : part
              ))}
            </p>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default ConnectionSetupGuide;
